import React from 'react';
import Translation from '../../../utilities/localizationUtility';
import { getDepositPrice, interpolatePriceToTemplate, priceFormat } from '../../../utilities/helperUtility';

export default function DepositPrice(props) {
  const {
    bodyStyles: { fontSize },
    depositAllowed,
    paymentOption,
    price,
    totalPrice,
    settings,
  } = props;
  const { depositSettings } = settings;
  const t = new Translation(settings);
  let value = price || totalPrice;
  let percentageLabel = '';
  if (!depositSettings || !depositAllowed || paymentOption !== 'payDeposit') return '';

  value = getDepositPrice(depositSettings, value);

  if (depositSettings.deposit_type === 'percentage') {
    percentageLabel = `${depositSettings.percentage}% `;
  }

  const deposit = t.key('deposit') || 'Deposit';

  return (
    <span style={{ fontSize, margin: 'auto auto auto 0' }}>
      <span>{`${percentageLabel}${deposit} - `}</span>
      <span
        dangerouslySetInnerHTML={{
          __html: interpolatePriceToTemplate(priceFormat(settings), value),
        }}
      />
    </span>
  );
}
